import { render, staticRenderFns } from "./ForcePassword.vue?vue&type=template&id=141059da&scoped=true"
import script from "./ForcePassword.vue?vue&type=script&lang=js"
export * from "./ForcePassword.vue?vue&type=script&lang=js"
import style0 from "./ForcePassword.vue?vue&type=style&index=0&id=141059da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141059da",
  null
  
)

export default component.exports